import { defineStore } from "pinia";
import { registrationManager } from "@/services/registration/registration-manager";

export const useRegistrationStore = defineStore({
  id: "Registration",
  state: () => {
    return {
      menu: [],
      alerts: [],
      alertCorrespondingTable: {},
    };
  },

  actions: {
    fetchMenu() {
      return registrationManager.menu().then((res) => {
        this.menu = res.items;
      });
    },

    pushAlerts(alerts = [], model) {
      if (Object.keys(alerts).length) {
        Object.values(alerts).forEach((alert) => {
          alert["fieldName"] = model.vars.label;
          this.pushAlert(alert);
        });
      }
    },

    pushAlert(alert) {
      const exist = this.alerts.find((item) => alert.id === item.id && item.fieldId === alert.fieldId);
      if (!exist) {
        this.alerts.push(alert);
      }
    },

    removeAlerts(alerts = []) {
      let returnedAlerts = this.alerts;
      if (Object.keys(alerts).length) {
        Object.values(alerts).forEach((alert) => {
          returnedAlerts = returnedAlerts.filter(
            (alertItem) => alertItem.id !== alert.id && alertItem.fieldId !== alert.fieldId,
          );
        });
      }
      this.alerts = returnedAlerts;
    },

    resetAlerts() {
      this.alerts = [];
    },

    addAlertToCorrespondingTable(alert, tab, block) {
      if (!alert || !alert.name) return;

      if (!this.alertCorrespondingTable[alert.name]) {
        this.alertCorrespondingTable[alert.name] = [];
      }

      let entry = this.alertCorrespondingTable[alert.name].find((item) => item.tab === tab && item.block === block);

      if (!entry) {
        entry = {
          tab: tab,
          block: block,
          fields: [],
        };
        this.alertCorrespondingTable[alert.name].push(entry);
      }

      if (alert.field) {
        const fieldExists = entry.fields.includes(alert.field);

        if (!fieldExists) {
          entry.fields.push(alert.field);
        }
      }
    },
  },
});
